import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import {Storage} from "@google-cloud/storage"

//const storage = new Storage();

// Fallback translations used before remote bundles load.
// Remote bundles (added via addResourceBundle with deep=true, overwrite=false in App.tsx)
// will NOT overwrite these keys — these serve as the baseline.
const resources = {
  en: {
    translation: {
      "Close hour": "Closing hour",
      Courier: "Courier",
      "Customer did not pick up / pay": "Customer did not pick up / pay",
      "This flags the order for a supervisor because the customer did not come to pick up. The supervisor can charge the backup card.":
        "This flags the order for a supervisor because the customer did not come to pick up. The supervisor can charge the backup card.",
      "This flags the order for a supervisor because the customer refused to pay. The supervisor can charge the backup card.":
        "This flags the order for a supervisor because the customer refused to pay. The supervisor can charge the backup card.",
      "Picked up by user": "Picked up by user",
      "Customer does not want to pay": "Customer does not want to pay",
      "Customer did not come to pickup": "Customer did not come to pickup",
      "Delivery price": "Delivery price",
      Edit: "Edit",
      "In restaurant": "In restaurant",
      Items: "Items",
      "Load more": "Load more",
      Notes: "Notes",
      "Open hour": "Opening hour",
      "Open hours": "Opening hours",
      "Order completed": "Order completed",
      "Order picked up": "Order picked up",
      Orderer: "Orderer",
      "Orders number": "Number of orders",
      "Payment method": "Payment method",
      cash: "Cash",
      card: "Card",
      "Pick up by orderer": "Pick up by orderer",
      "Please choose how much time it takes to prepare this order":
        "Please choose how much time it takes to prepare this order",
      Price: "Price",
      "Yala ticket": "Yala ticket",
      Reload: "Reload",
      "Reload App": "Reload app",
      "Report to supervisor?": "Report to supervisor?",
      "Reported to the supervisor for review":
        "Reported to the supervisor for review",
      "Something went wrong": "Something went wrong",
      SubItems: "Sub-items",
      "This flags the order for a supervisor to review. The supervisor can then charge the customer's backup card. Only do this if the customer did not come to pick up the order or refused to pay.":
        "This flags the order for a supervisor to review. The supervisor can then charge the customer's backup card. Only do this if the customer did not come to pick up the order or refused to pay.",
      "Time to prepare": "Time to prepare",
      "Total price": "Total price",
      "Total price for restaurant": "Total price for restaurant",
      "Unknown error": "Unknown error",
      "Yes, report it": "Yes, report it",
      close: "Close",
      "open drawer": "open drawer",
      unknown: "unknown",
      username: "Username",
      "New orders": "New orders",
      "No new orders": "No new orders",
      Preparing: "Preparing",
      "No orders preparing": "No orders preparing",
      Ready: "Ready",
      "No orders ready": "No orders ready",
      From: "From",
      To: "To",
      All: "All",
      Done: "Done",
      Cancelled: "Cancelled",
      "No orders found": "No orders found",
      you_have_received_new_order: "You have received a new order!",
      you_have_minutes_to_accept: "You have 4 minutes to accept the order",
      view_orders: "View orders",
      Printer: "Printer",
      "Print failed": "Print failed",
      "No printer selected":
        "No printer selected. Open printer settings and choose a thermal printer.",
      "Print timed out": "Print timed out. Check the printer and try again.",
      "Invalid receipt image": "Could not prepare the ticket for printing.",
      "Restaurant mode": "Restaurant mode",
      Busy: "Busy",
      Available: "Available",
      "Customers cannot place new orders": "Customers cannot place new orders",
      "Accepting new orders": "Accepting new orders",
      "Prepare this order by": "Prepare this order by",
      "New customer": "New customer",
      "Make his first order special": "Make his first order special",
      "Customer's note": "Customer's note",
      Discount: "Discount",
      "Final price": "Final price",
      "Delivery by courier": "Delivery by courier",
      "Self pickup": "Self pickup",
      Contact: "Contact",
      "Yala wishes you bon appetit": "Yala wishes you bon appetit",
    },
  },
  heb: {
    translation: {
      "Close hour": "שעת סגירה",
      Courier: "שליח",
      "Customer did not pick up / pay": "הלקוח לא אסף / לא שילם",
      "This flags the order for a supervisor because the customer did not come to pick up. The supervisor can charge the backup card.":
        "פעולה זו מסמנת את ההזמנה למפקח כי הלקוח לא הגיע לאיסוף. המפקח יוכל לחייב את כרטיס הגיבוי.",
      "This flags the order for a supervisor because the customer refused to pay. The supervisor can charge the backup card.":
        "פעולה זו מסמנת את ההזמנה למפקח כי הלקוח סירב לשלם. המפקח יוכל לחייב את כרטיס הגיבוי.",
      "Picked up by user": "נאסף על ידי הלקוח",
      "Customer does not want to pay": "הלקוח לא רוצה לשלם",
      "Customer did not come to pickup": "הלקוח לא הגיע לאיסוף",
      "Delivery price": "מחיר משלוח",
      Edit: "עריכה",
      "In restaurant": "במסעדה",
      Items: "פריטים",
      "Load more": "טען עוד",
      Notes: "הערות",
      "Open hour": "שעת פתיחה",
      "Open hours": "שעות פתיחה",
      "Order completed": "ההזמנה הושלמה",
      "Order picked up": "ההזמנה נאספה",
      Orderer: "מזמין",
      "Orders number": "מספר הזמנות",
      "Payment method": "אמצעי תשלום",
      cash: "מזומן",
      card: "כרטיס",
      "Pick up by orderer": "איסוף עצמי על ידי המזמין",
      "Please choose how much time it takes to prepare this order":
        "אנא בחר כמה זמן נדרש להכנת ההזמנה הזו",
      Price: "מחיר",
      "Yala ticket": "כרטיס Yala",
      Reload: "טעינה מחדש",
      "Reload App": "טעינת האפליקציה מחדש",
      "Report to supervisor?": "לדווח למפקח?",
      "Reported to the supervisor for review": "דווח למפקח לבדיקה",
      "Something went wrong": "משהו לא עבד כשורה",
      SubItems: "תת-פריטים",
      "This flags the order for a supervisor to review. The supervisor can then charge the customer's backup card. Only do this if the customer did not come to pick up the order or refused to pay.":
        "פעולה זו מסמנת את ההזמנה לבדיקת מפקח. לאחר מכן המפקח יכול לחייב את כרטיס הגיבוי של הלקוח. השתמש בה רק אם הלקוח לא הגיע לאסוף את ההזמנה או סירב לשלם.",
      "Time to prepare": "זמן הכנה",
      "Total price": "מחיר כולל",
      "Total price for restaurant": "מחיר כולל למסעדה",
      "Unknown error": "שגיאה לא ידועה",
      "Yes, report it": "כן, דווח",
      close: "סגירה",
      "open drawer": "פתיחת התפריט",
      unknown: "לא ידוע",
      username: "שם משתמש",
      "New orders": "הזמנות חדשות",
      "No new orders": "אין הזמנות חדשות",
      Preparing: "בהכנה",
      "No orders preparing": "אין הזמנות בהכנה",
      Ready: "מוכן",
      "No orders ready": "אין הזמנות מוכנות",
      From: "מתאריך",
      To: "עד תאריך",
      All: "הכל",
      Done: "הושלמה",
      Cancelled: "בוטלה",
      "No orders found": "לא נמצאו הזמנות",
      you_have_received_new_order: "!קיבלת הזמנה חדשה",
      you_have_minutes_to_accept: "יש לך 4 דקות לאשר את ההזמנה",
      view_orders: "צפייה בהזמנות",
      Printer: "מדפסת",
      "Print failed": "ההדפסה נכשלה",
      "No printer selected":
        "לא נבחרה מדפסת. פתח את הגדרות המדפסת ובחר מדפסת תרמית.",
      "Print timed out": "ההדפסה נכשלה עקב זמן קצוב. בדוק את המדפסת ונסה שוב.",
      "Invalid receipt image": "לא ניתן להכין את הכרטיס להדפסה.",
      "Restaurant mode": "מצב מסעדה",
      Busy: "עמוס",
      Available: "זמין",
      "Customers cannot place new orders": "לקוחות לא יכולים לבצע הזמנות חדשות",
      "Accepting new orders": "מקבל הזמנות חדשות",
      "Prepare this order by": "יש להכין את ההזמנה עד",
      "New customer": "לקוח חדש",
      "Make his first order special": "הפכו את ההזמנה הראשונה שלו למיוחדת",
      "Customer's note": "הערת הלקוח",
      Discount: "הנחה",
      "Final price": "מחיר סופי",
      "Delivery by courier": "משלוח עם שליח",
      "Self pickup": "איסוף עצמי",
      Contact: "איש קשר",
      "Yala wishes you bon appetit": "יאלה מאחלת לכם בתאבון",
    },
  },
  ar: {
    translation: {
      "Close hour": "ساعة الإغلاق",
      Courier: "المندوب",
      "Customer did not pick up / pay": "العميل لم يستلم / لم يدفع",
      "This flags the order for a supervisor because the customer did not come to pick up. The supervisor can charge the backup card.":
        "يؤدي هذا إلى تصنيف الطلب للمشرف لأن العميل لم يأتِ للاستلام. يمكن للمشرف الخصم من البطاقة الاحتياطية.",
      "This flags the order for a supervisor because the customer refused to pay. The supervisor can charge the backup card.":
        "يؤدي هذا إلى تصنيف الطلب للمشرف لأن العميل رفض الدفع. يمكن للمشرف الخصم من البطاقة الاحتياطية.",
      "Picked up by user": "تم الاستلام من قبل العميل",
      "Customer does not want to pay": "العميل لا يريد الدفع",
      "Customer did not come to pickup": "العميل لم يأتِ للاستلام",
      "Delivery price": "سعر التوصيل",
      Edit: "تعديل",
      "In restaurant": "في المطعم",
      Items: "الأغراض",
      "Load more": "تحميل المزيد",
      Notes: "ملاحظات",
      "Open hour": "ساعة الافتتاح",
      "Open hours": "ساعات العمل",
      "Order completed": "تم إكمال الطلب",
      "Order picked up": "تم استلام الطلب",
      Orderer: "الطالب",
      "Orders number": "عدد الطلبات",
      "Payment method": "طريقة الدفع",
      cash: "نقدي",
      card: "بطاقة",
      "Pick up by orderer": "استلام ذاتي من قبل الطالب",
      "Please choose how much time it takes to prepare this order":
        "يرجى اختيار الوقت اللازم لتحضير هذا الطلب",
      Price: "السعر",
      "Yala ticket": "تذكرة Yala",
      Reload: "إعادة تحميل",
      "Reload App": "إعادة تحميل التطبيق",
      "Report to supervisor?": "الإبلاغ للمشرف؟",
      "Reported to the supervisor for review": "تم الإبلاغ للمشرف للمراجعة",
      "Something went wrong": "حدث خطأ ما",
      SubItems: "الأغراض الفرعية",
      "This flags the order for a supervisor to review. The supervisor can then charge the customer's backup card. Only do this if the customer did not come to pick up the order or refused to pay.":
        "يؤدي هذا إلى تصنيف الطلب لمراجعة المشرف. ويمكن للمشرف بعد ذلك الخصم من البطاقة الاحتياطية للعميل. استخدمه فقط إذا لم يأتِ العميل لاستلام الطلب أو رفض الدفع.",
      "Time to prepare": "وقت التحضير",
      "Total price": "السعر الإجمالي",
      "Total price for restaurant": "السعر الإجمالي للمطعم",
      "Unknown error": "خطأ غير معروف",
      "Yes, report it": "نعم، أبلغ عنه",
      close: "إغلاق",
      "open drawer": "فتح القائمة",
      unknown: "غير معروف",
      username: "اسم المستخدم",
      "New orders": "طلبات جديدة",
      "No new orders": "لا توجد طلبات جديدة",
      Preparing: "قيد التحضير",
      "No orders preparing": "لا توجد طلبات قيد التحضير",
      Ready: "جاهز",
      "No orders ready": "لا توجد طلبات جاهزة",
      From: "من تاريخ",
      To: "إلى تاريخ",
      All: "الكل",
      Done: "تم",
      Cancelled: "ملغاة",
      "No orders found": "لا توجد طلبات",
      you_have_received_new_order: "!لقد استلمت طلبًا جديدًا",
      you_have_minutes_to_accept: "لديك 4 دقائق لقبول الطلب",
      view_orders: "عرض الطلبات",
      Printer: "الطابعة",
      "Print failed": "فشلت الطباعة",
      "No printer selected":
        "لم يتم اختيار طابعة. افتح إعدادات الطابعة واختر طابعة حرارية.",
      "Print timed out": "انتهت مهلة الطباعة. تحقق من الطابعة وحاول مرة أخرى.",
      "Invalid receipt image": "تعذر تجهيز التذكرة للطباعة.",
      "Restaurant mode": "وضع المطعم",
      Busy: "مشغول",
      Available: "متاح",
      "Customers cannot place new orders": "لا يمكن للعملاء تقديم طلبات جديدة",
      "Accepting new orders": "يستقبل طلبات جديدة",
      "Prepare this order by": "يجب تحضير الطلب حتى",
      "New customer": "عميل جديد",
      "Make his first order special": "اجعلوا طلبه الأول مميزًا",
      "Customer's note": "ملاحظة العميل",
      Discount: "خصم",
      "Final price": "السعر النهائي",
      "Delivery by courier": "توصيل بواسطة مندوب",
      "Self pickup": "استلام ذاتي",
      Contact: "للتواصل",
      "Yala wishes you bon appetit": "يالا تتمنى لكم وجبة شهية",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "heb",

  keySeparator: false,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
